var map = {
	"./alfalfa.svg": 67175,
	"./almond.svg": 64237,
	"./apple.svg": 73000,
	"./avocado.svg": 89235,
	"./barley.svg": 41019,
	"./carrot.svg": 67765,
	"./cherry.svg": 15071,
	"./citrus.svg": 27454,
	"./corn.svg": 91870,
	"./cotton.svg": 87953,
	"./grass-seed.svg": 40196,
	"./hops.svg": 97708,
	"./lemon.svg": 3465,
	"./mandarin.svg": 58056,
	"./melon.svg": 23469,
	"./mixed-vegetables.svg": 77882,
	"./olives.svg": 72980,
	"./onions.svg": 3586,
	"./peanut.svg": 91951,
	"./pecan.svg": 11625,
	"./pinto.svg": 85134,
	"./pistachio.svg": 78480,
	"./potato.svg": 55801,
	"./rice.svg": 56495,
	"./sorghum.svg": 67635,
	"./soybean.svg": 61897,
	"./sugar-beet.svg": 69135,
	"./sunflower.svg": 59663,
	"./timber.svg": 97665,
	"./walnut.svg": 1777,
	"./wheat.svg": 59401,
	"./wine-grapes.svg": 67132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50134;